const ENLIST_ERRORS = {
  NICKNAME_DUPLICATE: 'error_nickname_conflict',
  ROOM_NOT_STARTED: 'error_room_not_started',
  ROOM_LOCKED: 'error_room_locked',
  NOT_FOUND: 'error_meeting_not_found',
};

export default ENLIST_ERRORS;
